import { render, staticRenderFns } from "./HostemHeaderDropdown.vue?vue&type=template&id=0b80b5ca&lang=pug&"
import script from "./HostemHeaderDropdown.vue?vue&type=script&lang=js&"
export * from "./HostemHeaderDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports